// مسیر: frontend/src/components/layout/AppLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';

import AppTopBar from './AppTopBar'; 
import BottomNavigation from './BottomNavigation'; 
import SmartAssistantFAB from './SmartAssistantFAB'; 
import './AppLayout.css'; 

// ✅ ۱. ایمپورت AudioPlayer
import AudioPlayer from '../players/AudioPlayer'; // (خط ۱۵)

const AppLayout = () => {
    return (
        <div className="app-container">
            
            {/* 1. نوار بالا (fixed) */}
            <AppTopBar /> 
            
            {/* 🎧 پلیر صوتی ثابت: باید بالاتر از محتوای اصلی باشد */}
            {/* ✅ رندر AudioPlayer: این کامپوننت با کلاس‌های Tailwind خود (fixed top-0 z-50) 
                همیشه در بالای viewport ثابت خواهد ماند.
            */}
            <AudioPlayer /> 
            
            {/* 2. محتوای اصلی (قابل اسکرول) */}
            {/* 💡 نکته: اگر AudioPlayer در بالا قرار گرفته باشد، باید مطمئن شوید که 
                main.main-content-area به اندازه ارتفاع پلیر از بالا فاصله (padding-top) داشته باشد، 
                در غیر این صورت محتوا زیر پلیر پنهان می‌شود. این تنظیم معمولاً در AppLayout.css انجام می‌شود.
            */}
            <main className="main-content-area">
                <Outlet /> 
            </main>

            {/* 3. دکمه‌ها و نوار پایین (fixed) */}
            <BottomNavigation />
            
        </div>
    );
};

export default AppLayout;